export default __webpack_public_path__ + "static/media/flag_netherlands_antilles.63e3651d.svg";